(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["terplax-flavor-list"] && !Shopify.designMode) return;
  try {
    (() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const rows = [...root.querySelectorAll('[data-profile]')];
    const groups = [...root.querySelectorAll('[data-group]')];
    const selects = [...root.querySelectorAll('[data-filter]')];
    const search = root.querySelector('[data-search-input]');
    const buttons = [...root.querySelectorAll('[data-series]')];
    const topBtn = root.querySelector('[data-top]');
    const count = root.querySelector('[data-count]');
    const status = root.querySelector('[data-selection-status]');
    const tray = root.querySelector('[data-tray]');
    const chips = root.querySelector('[data-chips]');
    const quote = root.querySelector('[data-quote]');
    const selected = new Map();
    const all = Number(count.dataset.all) || rows.length;
    const norm = v => (v || '').toLowerCase().normalize('NFKD').replace(/[’‘]/g, "'").replace(/[–—]/g, '-');
    let series = 'all';
    let topOnly = false;

    selects.forEach(select => {
      const key = select.dataset.filter;
      const values = new Set();
      rows.forEach(row => {
        const raw = row.dataset[key];
        if (raw) (key === 'aroma' ? raw.split('/') : [raw]).forEach(v => v.trim() && values.add(v.trim()));
      });
      [...values].sort((a, b) => a.localeCompare(b)).forEach(value => {
        const o = document.createElement('option'); o.value = value; o.textContent = value; select.append(o);
      });
    });

    function update() {
      const terms = norm(search.value.trim()).split(/\s+/).filter(Boolean);
      const filtering = terms.length || topOnly || series !== 'all' || selects.some(s => s.value);
      let total = 0;
      groups.forEach(group => {
        let visible = 0;
        const groupRows = group.querySelectorAll('[data-profile]');
        groupRows.forEach(row => {
          const match = (series === 'all' || row.dataset.series === series)
            && (!topOnly || row.hasAttribute('data-hot'))
            && terms.every(t => norm(row.dataset.search).includes(t))
            && selects.every(s => !s.value || (s.dataset.filter === 'aroma'
              ? row.dataset.aroma.split('/').map(x => x.trim()).includes(s.value)
              : row.dataset[s.dataset.filter] === s.value));
          row.hidden = !match;
          if (match) visible++;
        });
        group.querySelectorAll('[data-fam]').forEach(fam => {
          let n = fam.nextElementSibling, any = false;
          while (n && !n.hasAttribute('data-fam')) { if (n.hasAttribute('data-profile') && !n.hidden) { any = true; break; } n = n.nextElementSibling; }
          fam.hidden = !any;
        });
        group.hidden = visible === 0;
        const c = group.querySelector('[data-group-count]');
        if (c) c.textContent = filtering && visible !== groupRows.length ? visible + ' of ' + groupRows.length + ' profiles' : groupRows.length + ' profiles';
        total += visible;
      });
      count.textContent = total + ' / ' + all + ' ' + count.dataset.label;
      root.querySelector('[data-empty]').hidden = total !== 0;
    }

    function selection() {
      chips.replaceChildren();
      selected.forEach(row => {
        const b = document.createElement('button'); b.type = 'button';
        b.textContent = row.dataset.id + ' ' + row.dataset.name + ' ×';
        b.setAttribute('aria-label', tray.dataset.remove + ' ' + row.dataset.id + ' ' + row.dataset.name);
        b.addEventListener('click', () => { row.querySelector('[data-pick]').checked = false; selected.delete(row.dataset.id); selection(); });
        chips.append(b);
      });
      tray.hidden = selected.size === 0;
      status.textContent = selected.size + ' / 8 ' + status.dataset.label;
      if (selected.size) {
        const lines = [...selected.values()].map(r => r.dataset.seriesName + ' — ' + r.dataset.id + ' ' + r.dataset.name);
        quote.href = 'https://wa.me/85246662726?text=' + encodeURIComponent(quote.dataset.intro + '\n' + lines.join('\n'));
      } else quote.removeAttribute('href');
      rows.forEach(r => { const p = r.querySelector('[data-pick]'); p.disabled = selected.size >= 8 && !p.checked; });
    }

    rows.forEach(row => row.querySelector('[data-pick]').addEventListener('change', event => {
      if (event.target.checked) { if (selected.size < 8) selected.set(row.dataset.id, row); else event.target.checked = false; }
      else selected.delete(row.dataset.id);
      selection();
    }));
    buttons.forEach(b => b.addEventListener('click', () => {
      series = b.dataset.series;
      buttons.forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      update();
    }));
    if (topBtn) topBtn.addEventListener('click', () => {
      topOnly = !topOnly;
      topBtn.setAttribute('aria-pressed', String(topOnly));
      topBtn.textContent = topOnly ? topBtn.dataset.on : topBtn.dataset.off;
      update();
    });
    function reset() {
      series = 'all'; topOnly = false; search.value = ''; selects.forEach(s => s.value = '');
      buttons.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.series === 'all')));
      if (topBtn) { topBtn.setAttribute('aria-pressed', 'false'); topBtn.textContent = topBtn.dataset.off; }
      update();
    }
    root.querySelectorAll('[data-reset]').forEach(b => b.addEventListener('click', reset));
    root.querySelector('[data-clear-selection]').addEventListener('click', () => {
      selected.clear(); rows.forEach(r => r.querySelector('[data-pick]').checked = false); selection();
    });
    search.addEventListener('input', update);
    selects.forEach(s => s.addEventListener('change', update));
    root.querySelector('[data-tools]').hidden = false;
    root.querySelectorAll('[data-pick-wrap]').forEach(e => e.hidden = false);
    update();
  }
  document.querySelectorAll('[data-flavor-finder]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-flavor-finder]').forEach(init));
})();
  } catch(e) { console.error(e); }
})();

})();
